// extracted by mini-css-extract-plugin
module.exports = {"vodCardWrapper":"vod-list_vodCardWrapper__2PHn9","ant-card-body":"vod-list_ant-card-body__2d4KP"};